define('ItemBadges.BadgesList.View', [
    'Backbone',
    'itembadges_list.tpl'
], function ItemBadgesBadgesListView(
    Backbone,
    itembadgesListTpl
) {
    'use strict';

    return Backbone.View.extend({
        template: itembadgesListTpl,

        initialize: function initialize(options) {
            this.model = options.model;
            this.view = options.currentView;
        },

        getContext: function getContext() {
            return {
                model: this.model,
                bgcolor: this.model.get('bgColor'),
                name: this.model.get('name'),
                icon: this.model.get('icon'),
                weight: this.model.get('weight'),
                alt: this.model.get('alt'),
                showIcon: this.model.get('icon').internalid || false,
                showText: (!this.model.get('icon').internalid),
                isPdp: (this.view === 'pdp')
            };
        }
    });
});
